import React, { useEffect } from "react";
import style from "../../sass/navigation.module.scss";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { navAction } from "../../redux/navSlice";
import ShowNavList from "./ShowNavList";
import { createPortal } from "react-dom";
import { useMediaQuery } from "react-responsive";

const Hamburger = () => {
     const isHamburgerOpen = useMediaQuery({ query: "(max-width: 1065px)" });
     const { isOpen } = useSelector((state) => state.navigation);
     const dispatch = useDispatch();
     const handleNavList = () => {
          dispatch(navAction.updateNavListOpen());
     };

     // useEffect(() => {
     //      if (isHamburgerOpen) {
     //           dispatch(navAction.updateNavListOpen());
     //      }
     // }, [isHamburgerOpen]);

     return (
          <div className={style.navigation_hamburger} onClick={handleNavList}>
               <div className={style.navigation_hamburger_box}>
                    <div className={style.navigation_hamburger_box_heading}>{!isOpen ? "Menu" : "Close"}</div>
                    {!isOpen ? <GiHamburgerMenu /> : <IoClose />}
                    {isOpen && isHamburgerOpen && createPortal(<ShowNavList />, document.getElementById("nav"))}
               </div>
          </div>
     );
};
export default Hamburger;
